function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icon';
import MenuGroup from './MenuGroup';
import Button from '../Button';
import OpenableComponent from '../OpenableComponent';
import classNames from '../utils/classNames';
import ClickAway from '../ClickAway';
import FocusTrap from '../FocusTrap';
/**
 * The DropdownMenu component provides a stylable version of the select element.
 * It is used to select a value or set of values from a fixed list of options.
 *
 * - [MDN Docs on Select](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/select)
 *
 * ## Composed of
 * - [ClickAway](../ClickAway/README.md)
 * - [FocusTrap](../FocusTrap/README.md)
 *
 * ## Related Components
 * - [MenuGroup](../MenuGroup/README.md)
 * - [MenuOption](../MenuOption/README.md)
 *
 * ## Usage
 *
 * ```jsx
 * <DropdownMenu
 *    value="two"
 *    variant="option"
 *    name="count"
 *    onChange={({ target: { value } }) => console.log('changed value to', value)}
 * >
 *    <MenuOption value="one">Option One</MenuOption>
 *    <MenuOption value="two">Option Two</MenuOption>
 * </DropdownMenu>
 * ```
 *
 * ## Props
 */

var DropdownMenu = /*#__PURE__*/function (_OpenableComponent) {
  _inherits(DropdownMenu, _OpenableComponent);

  var _super = _createSuper(DropdownMenu);

  function DropdownMenu() {
    var _this;

    _classCallCheck(this, DropdownMenu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "_handleKeyDown", function (event) {
      var keyCode = event.keyCode;
      var isArrowDown = keyCode === 40;
      var isArrowUp = keyCode === 38;

      if (isArrowUp || isArrowDown) {
        _this.open();

        event.preventDefault();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_toggleOpen", function () {
      if (_this.isOpen()) {
        _this.close();
      } else {
        _this.open();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_onOption", function (event) {
      var _this$props = _this.props,
          onOption = _this$props.onOption,
          onChange = _this$props.onChange,
          value = _this$props.value,
          iconType = _this$props.iconType,
          handleValueChange = _this$props.handleValueChange,
          handleIconTypeChange = _this$props.handleIconTypeChange;

      if (typeof onOption === 'function') {
        onOption(event);
      }

      if (iconType) {
        handleIconTypeChange(event.currentTarget.id);
      }

      if (value !== event.target.value) {
        if (typeof handleValueChange === 'function') {
          handleValueChange(event.target.value);
        } else if (typeof onChange === 'function') {
          onChange(event);
        }
      }

      _this.close();
    });

    return _this;
  }

  _createClass(DropdownMenu, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          qa = _this$props2.qa,
          label = _this$props2.label,
          className = _this$props2.className,
          name = _this$props2.name,
          disabled = _this$props2.disabled,
          children = _this$props2.children,
          value = _this$props2.value,
          optionType = _this$props2.optionType,
          variant = _this$props2.variant,
          chevron = _this$props2.chevron,
          iconType = _this$props2.iconType,
          onSelectedChosen = _this$props2.onSelectedChosen,
          chevronAnimation = _this$props2.chevronAnimation,
          capsuleVariantProps = _this$props2.capsuleVariantProps;
      var isOpen = this.isOpen();

      var _DropdownMenu$getClas = DropdownMenu.getClassName({
        className: className,
        isOpen: isOpen,
        disabled: disabled,
        variant: variant,
        chevronAnimation: chevronAnimation
      }),
          dropdownMenu = _DropdownMenu$getClas.dropdownMenu,
          inlayedStyle = _DropdownMenu$getClas.inlayedStyle,
          trigger = _DropdownMenu$getClas.trigger,
          triggerIcon = _DropdownMenu$getClas.triggerIcon,
          selectionBacker = _DropdownMenu$getClas.selectionBacker,
          root = _DropdownMenu$getClas.root,
          capsuleButton = _DropdownMenu$getClas.capsuleButton,
          capsuleButtonText = _DropdownMenu$getClas.capsuleButtonText;

      return /*#__PURE__*/React.createElement(ClickAway, {
        onClickAway: this.close,
        "data-qa": qa,
        "data-name": name,
        className: root
      }, /*#__PURE__*/React.createElement("div", {
        className: dropdownMenu
      }, variant === 'capsule' && /*#__PURE__*/React.createElement(Button, _extends({}, capsuleVariantProps, {
        onClick: onSelectedChosen,
        variant: "content",
        className: capsuleButton,
        qa: "".concat(qa, "#chooseSelected"),
        disabled: disabled
      }), /*#__PURE__*/React.createElement("span", {
        style: {
          alignItems: 'center'
        },
        className: capsuleButtonText
      }, label)), /*#__PURE__*/React.createElement("div", {
        className: inlayedStyle
      }, /*#__PURE__*/React.createElement(Button, _extends({}, this.props, {
        qa: "".concat(qa, "#select"),
        active: isOpen,
        className: trigger,
        ariaHaspopup: true,
        ariaExpanded: isOpen,
        variant: "content",
        onKeyDown: this._handleKeyDown,
        onClick: this._toggleOpen
      }), /*#__PURE__*/React.createElement("div", {
        className: "psw-t-truncate-1",
        "data-qa": "".concat(qa, "#label")
      }, variant === 'capsule' ? /*#__PURE__*/React.createElement(Icon, {
        type: iconType,
        size: "3",
        className: disabled && 'psw-light-theme psw-is-disabled'
      }) : label), chevron && /*#__PURE__*/React.createElement(Icon, {
        className: triggerIcon,
        type: "chevron-down",
        size: "3"
      }))), isOpen && /*#__PURE__*/React.createElement(FocusTrap, {
        className: selectionBacker,
        allowArrowKeys: true,
        allowTabTraversal: false,
        onEscape: this.close,
        strategy: "focusable"
      }, /*#__PURE__*/React.createElement(MenuGroup, {
        qa: qa,
        value: value,
        iconType: iconType,
        onOption: this._onOption,
        optionType: optionType
      }, children)), isOpen && variant === 'inlayed' && /*#__PURE__*/React.createElement("div", {
        className: classNames('psw-c-bg-1', 'psw-fill-x', 'psw-p-2', 'psw-l-anchor-bottom-center', 'psw-l-bottom-center', 'psw-l-z-1')
      })));
    }
  }]);

  return DropdownMenu;
}(OpenableComponent);

DropdownMenu.getClassName = function (_ref) {
  var className = _ref.className,
      variant = _ref.variant,
      isOpen = _ref.isOpen,
      disabled = _ref.disabled,
      chevronAnimation = _ref.chevronAnimation;
  var disabledClassnames = classNames('psw-c-bg-action-1', 'psw-c-bg-interactive-1');
  return {
    root: classNames('psw-dropdown-menu', isOpen && 'psw-is-open', 'psw-l-shrink-wrap'),
    dropdownMenu: classNames('psw-l-line-left', 'psw-l-anchor', _defineProperty({}, classNames('psw-dark-theme'), variant === 'capsule' && disabled)),
    inlayedStyle: classNames("psw-".concat(variant, "-dropdown"), isOpen && 'psw-is-open', 'psw-dropdown-trigger', disabled && 'psw-is-disabled', className, _defineProperty({}, classNames('psw-r-1'), variant === 'inlayed'), _defineProperty({}, classNames(!disabled && 'psw-c-bg-interactive-1', !disabled && 'psw-c-bg-1', 'psw-r-right-4', 'psw-border-l-s', disabled && 'psw-c-b-action-off'), variant === 'capsule')),
    capsuleButton: classNames('psw-r-left-4', 'psw-ally-indicator', 'psw-ally-indicator-gap-0', 'psw-ally-indicator-inset', 'psw-p-y-3', 'psw-c-bg-1', disabled ? disabledClassnames : 'psw-c-bg-interactive-2', 'psw-capsule-button'),
    capsuleButtonText: classNames('psw-t-align-c', 'psw-l-line-center', 'psw-p-x-6', 'psw-l-h-icon-3', 'psw-t-link', 'psw-t-bold', 'psw-fill-x', _defineProperty({}, classNames('psw-light-theme', 'psw-is-disabled'), disabled)),
    trigger: classNames('psw-l-line-center', 'psw-p-y-3', 'psw-t-bold', 'psw-t-link', 'psw-clip', 'psw-ally-indicator', 'psw-ally-indicator-inset', 'psw-disable-nested-focus', 'psw-ally-indicator-gap-0', _defineProperty({}, classNames('psw-r-1', 'psw-c-t-accent', 'psw-p-x-5'), variant === 'inlayed'), _defineProperty({}, classNames('psw-r-right-4', 'psw-p-x-3', disabled && disabledClassnames), variant === 'capsule'), _defineProperty({}, classNames('psw-is-open'), isOpen)),
    triggerIcon: classNames('psw-menu-icon', isOpen && 'psw-is-open', chevronAnimation && 'psw-menu-icon-anim', _defineProperty({}, classNames('psw-light-theme', 'psw-c-t-disabled'), disabled && variant === 'capsule')),
    selectionBacker: classNames('psw-clip', 'psw-l-z-1', 'psw-scroll-y', 'psw-l-stack-left', _defineProperty({}, classNames('psw-s-2', 'psw-c-bg-1', 'psw-dropdown-backer', 'psw-r-bottom-top-left-1', 'psw-l-anchor-bottom-right', 'psw-l-top-right'), variant === 'inlayed'), _defineProperty({}, classNames('psw-capsule-backer', 'psw-r-1', 'psw-l-anchor-bottom-center', 'psw-l-top-center'), variant === 'capsule'))
  };
};

DropdownMenu.defaultProps = {
  qa: '',
  id: '',
  className: '',
  name: '',
  label: '',
  value: null,
  disabled: false,
  isOpen: null,
  onChange: null,
  onOption: null,
  optionType: 'selection',
  ariaLabel: '',
  trackClick: null,
  telemetryMeta: null,
  variant: 'inlayed',
  chevron: true,
  chevronAnimation: true,
  onOpen: function onOpen() {},
  onClose: function onClose() {},
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  iconType: null,
  handleValueChange: null,
  handleIconTypeChange: null,
  onSelectedChosen: function onSelectedChosen() {}
};
DropdownMenu.propTypes = {
  /**
   * QA selector attribute used to target important elements for test validation
   */
  qa: PropTypes.string,

  /**
   * Unique id for the control, used to associate additional labels with the for attribute
   */
  id: PropTypes.string,

  /**
   * Allows adding a custom class or series of classes on the component
   * useful for setting margin or padding
   */
  className: PropTypes.string,

  /**
   * Allows passing props to the capsule button
   */
  capsuleVariantProps: PropTypes.shape({
    ariaLabel: PropTypes.string
  }),

  /**
   * Presentational variants supported
   */
  variant: PropTypes.oneOf(['inlayed', 'capsule']),

  /**
   * Whether of not the dropdown menu should be open
   */
  isOpen: PropTypes.bool,

  /**
   * event callback to be called when a users mouse enters the button or children within
   */
  onMouseEnter: PropTypes.func,

  /**
   * The name associated with the pseudo form element
   */
  name: PropTypes.string,

  /**
   * The placeholder label
   */
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),

  /**
   * The selected value(s)
   */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),

  /**
   * MenuGroup or MenuOptions to show within the dropdown
   */
  children: PropTypes.node.isRequired,

  /**
   * Whether or not the dropdown can be opened and selected
   */
  disabled: PropTypes.bool,

  /**
   * event callback called when a selected value has changed
   */
  onChange: PropTypes.func,

  /**
   * event callback called when an option item has been clicked
   */
  onOption: PropTypes.func,

  /**
   * event callback called when an capsule button has been clicked to launch selection
   */
  onSelectedChosen: PropTypes.func,

  /**
   * event callback called when the options should be shown
   */
  onOpen: PropTypes.func,

  /**
   * event callback called when the options should be closed
   */
  onClose: PropTypes.func,

  /**
   * event callback to be called when the button is focused
   */
  onFocus: PropTypes.func,

  /**
   * event callback to be called when the button loses focus
   */
  onBlur: PropTypes.func,

  /*
  * sets the type of dropdown Menu
  */
  optionType: PropTypes.oneOf(['selection', 'option', 'darkSelection']),

  /**
   * Aria label for button. Be aware that screen reader will always use this value if provided
   */
  ariaLabel: PropTypes.string,

  /**
   * The spec id identifying the interaction
   */
  trackClick: PropTypes.string,

  /**
   * Serialized json data of context specific telemetry data
   */
  telemetryMeta: PropTypes.string,

  /**
   * whether or not you want to include the chevron icon in the CTA label
   */
  chevron: PropTypes.bool,

  /**
   * whether or not you want to include animation for the chevron icon in the CTA label
   */
  chevronAnimation: PropTypes.bool,

  /**
    * String of the icon type to be shown in the cta
    */
  iconType: PropTypes.string,

  /**
    * event callback called when a selected value has changed for capsule variant
    */
  handleValueChange: PropTypes.func,

  /**
   * event callback called when an icon value has changed for capsule variant
   */
  handleIconTypeChange: PropTypes.func
};
export default DropdownMenu;